export default __webpack_public_path__ + "static/media/NextFixed.996ebd41.svg";